var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"14c0c99039155a51e99788049118e86649307ce3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@blickfang"]={id:"14c0c99039155a51e99788049118e86649307ce3"};
      